import React from 'react'
import { Modal } from 'reactstrap';

const WaitingPopup = ({
    state,
    setState,
    message,
    size
}: any) => {
    const handlePopUpState = () => {
        setState(!state);
    }
    return (
        <Modal
            size={size ?? 'sm'}
            isOpen={state}
            toggle={() => {
                handlePopUpState();
            }}
            backdrop={"static"}
            id="staticBackdrop"
            modalClassName="custom-transparent-modal"
        >
            <div
                className={`alert-border-left mb-0 alert alert-warning alert-dismissible fade show ${size === "md" ? "w-40" : "w-10"}`}
                role="alert">
                <i className="bx bx-loader bx-spin font-size-16 align-middle me-2" />
                <strong>{message}</strong>
            </div>
        </Modal>
    )
}

export default WaitingPopup